import { Icon, FormField, InputText } from 'ui';
import FooterButtons from 'core/modules/compositions/FooterButtons';
import { ValidateEmail } from 'core/utils/utils';
import React, { useState } from 'react';

// import Icon from '../../atoms/Icon';
// import { lessonType } from '../../../variables/constant';

const ForgotPasswordForm = ({ t, onCancel, onSuccess, state }) => {
  const [email, setEmail] = useState('');

  function onSendEmail() {
    onSuccess(email);
  }

  return (
    <div className="forgot-password-form">
      {state === 'success' ? (
        <div className="forgot-password__success">
          <Icon name="check-checked-round-fill" color="primary" size="3xl" />
          <div className="forgot-password__success-text">{t('recover:Great! Review you inbox to see the instructions')}</div>
        </div>
      ) : (
        <div>
          <div className="forgot-password__subtitle">{t('login:Type your email to receive a recover link')}</div>
          <FormField isLabelHidden label={t('login:Type your email to receive a recover link')}>
            <InputText
              placeholder={t('tucorreo@email.com')}
              value={email}
              onChange={(e) => {
                setEmail(e.currentTarget.value);
              }}
            />
          </FormField>
          <div className="new-lesson-form__buttons">
            <FooterButtons
              buttonTextCancel={t('actions:Cancel')}
              buttonTextSucess={t('actions:Send')}
              onCancel={onCancel}
              onSuccess={onSendEmail}
              disabledSuccess={!ValidateEmail(email)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

ForgotPasswordForm.defaultProps = {
  onCancel: () => {},
  onSuccess: () => {},
};

export default ForgotPasswordForm;
